import { Outlet, useLoaderData } from "react-router-dom";

const PrivateRoute = () => {
    
    const { config, accessToken, user, permissionMasks, permissions } = useLoaderData()

    // this component just wraps our secure routes and sets context from the loader data
    // at this point the useris logged in and we have access to the user manifest, app config data and accessToken

    return (
        <Outlet context={{ config: config, accessToken: accessToken, user: user, permissionMasks: permissionMasks, permissions: permissions }} />
    )
}

export default PrivateRoute